interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  icon: string;
}

export default function SectionHeading({ eyebrow, title, desc, icon }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">{eyebrow}</p>
          <h2 className="mt-1 text-xl font-black text-foreground-950 md:text-3xl">{title}</h2>
        </div>
      </div>
      {desc ? <p className="max-w-xl text-sm leading-relaxed text-foreground-600 md:text-right">{desc}</p> : null}
    </div>
  );
}